import React, { useState, useEffect } from "react";
import "../../components/PetBreed/PetBreed.css";
import axios from "axios";


const PetBreed = ({tokenStorage,openProfile,setOpenProfile, selectedPetBreedID }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [petType, setPetType] = useState([]);
  const [petbreedType, setPetbreedType] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;


  const [formData, setFormData] = useState({
    ID: selectedPetBreedID,
    PetTypeID: "",
    PetBreedType1: "",
    createdBy: "Vishal",
  });

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));   
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GEPetType?PetType=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          //console.log(response.data.data);
          setPetType(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(`${baseAPI}adminget/GEPetBreedType?PetBreedID=${selectedPetBreedID}&PetType=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response1) => {        
          const petBreeds = response1.data.data;
          if (petBreeds && petBreeds.length > 0) {
            setPetbreedType(petBreeds[0]);
            setFormData({
              ...formData,
              PetBreedType1: petBreeds[0].PetBreedType,
              PetTypeID: petBreeds[0].PetTypeID,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, [selectedPetBreedID]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddPetBreed`,
        formData, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      ); 
      setFormData({
        PetTypeID: "",
        PetBreedType1: "",
        createdBy: "Vishal",
      });
      setPetbreedType({
        PetTypeID: "",
        PetBreedType: "",
      });
      tokenStorage();
      setOpenProfile (!openProfile);
    }catch (error) {      
      console.error("Error posting data:", error);
    }    
  }

  const handleddlChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    
    setPetbreedType(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));
  };

  const handleBreedChange = (e) => {
    setFormData({
      ...formData,
      PetBreedType1: e.target.value
    });

    setPetbreedType(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));
  };



  return (
    <div className="container-fluid">
      <br />

      <div className="petBreedDetail">
        <div className="petBreedDetailHeader">
          <div className="ClearTab">
            <button className={isEditMode ? "saveButton" : "closeTabButton"} onClick={handleSubmit} >
              {isEditMode ? "Save" : "Close Tab"}
            </button>
            <button
              className={isEditMode ? "CancelButton" : "editButton"}
              onClick={toggleEditMode}
            >
              {/* Edit {isEditMode ? "" : ""} */}
              {isEditMode ? "Cancel" : "Edit"}
            </button>
          </div>
        </div>

        {/* ---------------------------------------------------------------------------------------------------------------- */}
        {isEditMode ? (
          // --------------Edit mode---------------//
          <form className="petBreed-form">

            <table style={{ width: "100%" }}>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Pet Type*</td>
                <td>Breed*</td>

              </tr>

              <tr>
                <td>
                  <select
                    className="form-control"
                    name="PetTypeID"
                    value={petbreedType.PetTypeID}
                    onChange={handleddlChange}

                  >
                    <option value="0">Select an option</option>
                    {petType.map((item) => (
                      <option value={item.id}>{item.petType}</option>
                    ))}
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    name="PetBreedType"
                    value={petbreedType.PetBreedType}
                    placeholder="Please Enter*"
                    onChange={handleBreedChange}

                  />
                </td>

              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
            </table>

          </form>
        ) : (
          // --------------Display mode---------------//
          <div>
            {petbreedType && (
              <table style={{ width: "100%" }}>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>Pet Type</td>
                  <td>Pet Breed</td>
                </tr>

                <tr>
                  <td>{petbreedType.PetType}</td>
                  <td>{petbreedType.PetBreedType}</td>
                </tr>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
              </table>
            )}
          </div>
        )}
      </div>
      <br />
    </div>
  );
};

export default PetBreed;
